import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  UpdateMultipleTemplateResponseRequestObjectType,
  UpdateMultipleTemplateResponseResponseType
} from '../../../services/NwApplicationServices/APIService/types';

import { useNwApplicationService } from '../useNwApplicationService';

interface UseUpdateMultipleTemplateResponseInterface {
  updateMultipleTemplateResponseApi: UseMutateAsyncFunction<
    UpdateMultipleTemplateResponseResponseType,
    unknown,
    UpdateMultipleTemplateResponseRequestObjectType,
    unknown
  >;
  error: string;
  status: MutationStatus;
}

const useUpdateMultipleTemplateResponse =
  (): UseUpdateMultipleTemplateResponseInterface => {
    const { nwApplicationService } = useNwApplicationService();

    const updateMultipleTemplateResponse = (
      requestObject: UpdateMultipleTemplateResponseRequestObjectType
    ) => {
      return nwApplicationService.updateMultipleTemplateResponse(requestObject);
    };

    const { mutateAsync, error, status } = useMutation(
      updateMultipleTemplateResponse,
      {
        mutationKey: ['updateMultipleTemplateResponseApi']
      }
    );

    return {
      updateMultipleTemplateResponseApi: mutateAsync,
      error: error ? getAPIErrorMessage(error) : '',
      status
    };
  };

export { useUpdateMultipleTemplateResponse };
